import BuilderUtil from '@builder/utils/BuilderUtil';
import Vue from 'vue';

const state = {
    mode: 'action',

    html: null, // Initial HTML.
    action: {}, // Params.

    library: [], // Default block library.
    libraryCustom: [], // Project block library.
    templates: [], // Template library.

    selectedPanel: null,
    selectedBlockIndex: null,
    selectedModal: null,
    selectedModalParams: {},
    selectedTemplate: null,
    selectedLink: null,
    selectedRange: null,
}

const getters = {

    mode: state => {
        return state.mode;
    },

    html: state => {
        return state.html;
    },

    action: state => {
        return state.action;
    },

    blocks: state => {
        return state.action.blocks;
    },

    library: state => {
        return state.library;
    },

    libraryCustom: state => {
        return state.libraryCustom;
    },

    templates: state => {
        return state.templates;
    },

    selectedPanel: state => {
        return state.selectedPanel;
    },

    selectedBlock: state => {
        return state.action.blocks[state.selectedBlockIndex];
    },

    selectedBlockIndex: state => {
        return state.selectedBlockIndex;
    },

    selectedLink: state => {
        return state.selectedLink;
    },

    selectedModal: state => {
        return state.selectedModal;
    },

    selectedModalParams: state => {
        return state.selectedModalParams;
    },

    selectedTemplate: state => {
        return state.selectedTemplate;
    },

    selectedRange: state => {
        return state.selectedRange;
    },

}

const mutations = {

    reset(state) {
        state.mode = 'action';
        state.html = null;
        state.action = {};
        state.library = [];
        state.libraryCustom = [];
        state.templates = [];
        state.selectedPanel = null;
        state.selectedBlockIndex = null;
    },

    setMode(state, mode) {
        state.mode = mode;
    },

    setHtml(state, html) {
        state.html = html;
        state.selectedPanel = null;
        state.selectedBlockIndex = null;
    },

    setAction(state, action) {
        state.action = action;
        state.selectedPanel = null;
        state.selectedBlockIndex = null;
    },

    setBlocks(state, blocks) {
        Vue.set(state.action, 'blocks', blocks);
    },

    setSettings(state, action) {
        Vue.set(state.action, 'format', action.format);
        Vue.set(state.action, 'background_color', action.background_color);
    },

    setLibrary(state, library) {
        state.library = library;
    },

    setLibraryCustom(state, libraryCustom) {
        state.libraryCustom = libraryCustom;
    },

    setTemplates(state, templates) {
        state.templates = templates;
    },

    setSelectedPanel(state, panel) {
        state.selectedPanel = panel;
        if (panel === null) {
            BuilderUtil.deactivateBlockElements();
        }
    },

    setSelectedBlock(state, block) {
        let index = state.selectedBlockIndex;
        Vue.set(state.action.blocks, index, block);
        BuilderUtil.updateBlockElementAtIndex(index);
    },

    setSelectedBlockIndex(state, index) {
        state.selectedPanel = null;
        Vue.nextTick(() => {
            let block = state.action.blocks[index];
            state.selectedBlockIndex = index;
            state.selectedPanel = block.type;
        });
    },

    setSelectedModal(state, slug) {
        state.selectedModal = slug;
    },

    setSelectedModalParams(state, params) {
        state.selectedModalParams = params;
    },

    setSelectedTemplate(state, template) {
        state.selectedTemplate = template;
    },

    setSelectedLink(state, link) {
        state.selectedLink = link;
    },

    setSelectedRange(state, range) {
        state.selectedRange = range;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}